export default __webpack_public_path__ + "static/media/jobBanner.9236e939.jpg";